import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';
import routes from './Router';
import * as serviceWorker from './serviceWorker';
import userService from './user.service.js';
import useStore, { getCaregivers, getCareRecipients } from './Store/Store';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import Snackbar from './components/Snackbar.jsx';
import { onMessageListener } from './utils/firebaseNotificationConfigs.js';
import CompanionChat from './CanCare/Components/CompanionChat.jsx';

const queryClient = new QueryClient();

const PrivateRoute = ({ Component }) => {
  const user = useStore((state) => state.user);
  const [state, setState] = React.useState({
    open: false,
    message: '',
    body: '',
  });

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        const { notification } = payload;
        setState({
          open: true,
          message: notification.title,
          body: notification.body,
        });
      })
      .catch((err) => console.error('Failed to setup notification listener:', err));

    return () => {};
  }, []);

  return (
    <>
      {user ? <Component /> : <Navigate to="/login" replace />}
      <Snackbar
        open={state.open}
        handleClose={() => setState({ open: false, message: '', body: '' })}
        variant="standard"
        message={state.message}
        body={state.body}
      />
    </>
  );
};

const routing = (
  <>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          {routes.map((route, i) => {
            if (route.private) {
              return <Route key={i} path={route.path} element={<PrivateRoute Component={route.component} />} />;
            }
            return <Route key={i} path={route.path} element={<route.component />} />;
          })}
        </Routes>
        <CompanionChat />
      </Router>
    </QueryClientProvider>
  </>
);

const authData = userService.getAuthData();

if (
  !isEmpty(authData.currentUserId) &&
  !isEmpty(authData.accessToken) &&
  authData.currentUserId !== 'null' &&
  authData.accessToken !== 'null'
) {
  fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/users/${authData.currentUserId}/userInfo`, {
    method: 'GET',
    headers: {
      authorization: authData.accessToken + '~123123',
    },
  })
    .then((res) => res.json())
    .then(async ({ data: userData }) => {
      if (!userData.error) {
        useStore.getState().updateUser(userData);
        userService.updateCurrentUser(userData);

        await getCareRecipients({ userId: userData?._id });
        await getCaregivers({ userId: userData?._id });
      }

      ReactDOM.render(routing, document.getElementById('root'));
    })
    .catch((err) => {
      console.log(err);
    });
} else {
  ReactDOM.render(routing, document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
